import clsx from 'clsx';

import s from './LinearProgressBar.module.scss';

interface Props {
  className?: string;
  value: number;
}

const MIN_PROGRESS = 0;
const MAX_PROGRESS = 100;

export const LinearProgressBar = ({ className, value }: Props) => {
  const normalizedValue = Math.min(MAX_PROGRESS, Math.max(MIN_PROGRESS, value));

  return (
    <div className={clsx(s.track, className)}>
      <div className={s.fill} style={{ width: `${normalizedValue}%` }} />
    </div>
  );
};
